// extracted by mini-css-extract-plugin
export default {"loading":"search_pagination_loader-module__loading--Nb--G"};